/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	Component
} from '@angular/core';
import {
	PageContextDirective
} from '@shared/directives/page-context.directive';
import {
	ResolverService
} from '@shared/services/resolver.service';

@Component({
	selector: 'app-maintenance',
	templateUrl: './maintenance.component.html'
})

/**
 * A component representing an instance of the system maintenance
 * component.
 *
 * @export
 * @class MaintenanceComponent
 * @extends {PageContextDirective}
 */
export class MaintenanceComponent
	extends PageContextDirective
{
	/**
	 * Creates an instance of the maintenance component.
	 *
	 * @param {ResolverService} resolver
	 * The resolver service used for dynamic logic and business rules.
	 * @memberof MaintenanceComponent
	 */
	public constructor(
		public resolver: ResolverService)
	{
		super(resolver);
	}
}